import React, { ReactNode } from 'react';
import moment from 'moment';
import { Typography, Stack } from '@mui/material';
import { red, green } from '@mui/material/colors';
import { Close, DoneAll } from '@mui/icons-material';
import { DateFormats } from '../../../constants/common';

const renderByStatus: Record<
  'SUCCESS' | 'FAILED',
  {
    icon: ReactNode;
    borderColor: string;
    prefix: 'Won' | 'Lost';
    backgroundColor: string;
    textColor: 'error' | 'success';
  }
> = {
  SUCCESS: {
    prefix: 'Won',
    textColor: 'success',
    borderColor: green[100],
    backgroundColor: green[50],
    icon: <DoneAll color="success" />,
  },
  FAILED: {
    prefix: 'Lost',
    textColor: 'error',
    borderColor: red[100],
    backgroundColor: red[50],
    icon: <Close color="error" />,
  },
};

interface Props {
  id: string;
  isClosed: boolean;
  reasonLabel: string;
  closedDateTime: string;
  closeDealStatus: 'SUCCESS' | 'FAILED';
}

export const ClosedDealInfo = ({ closeDealStatus, closedDateTime, reasonLabel }: Props) => {
  return (
    <Stack
      sx={{
        gap: '0.5rem',
        padding: '0.5rem',
        flexDirection: 'row',
        borderRadius: '0.5rem',
        backgroundColor: renderByStatus[closeDealStatus].backgroundColor,
        border: `1px solid ${renderByStatus[closeDealStatus].borderColor}`,
      }}
    >
      {renderByStatus[closeDealStatus].icon}

      <Stack>
        <Typography component="span" variant="subtitle2" color={renderByStatus[closeDealStatus].textColor}>
          {renderByStatus[closeDealStatus].prefix}: {moment(closedDateTime).format(DateFormats.TimeWithShortDate)}
        </Typography>

        <Typography component="span" variant="subtitle2" color={renderByStatus[closeDealStatus].textColor}>
          {reasonLabel}
        </Typography>
      </Stack>
    </Stack>
  );
};
